import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDropDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7 10l5 5 5-5H7z" })
});
export default SvgArrowDropDown;
